module.exports = __webpack_public_path__ + "img/kv-right-bottom.3f94e99b.png";